import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Shared placeholder used by every V2 page in PR2 until the real
 * implementations land in later PRs. Centralizing the layout here keeps every
 * page responsive + consistent for free.
 */ export function PlaceholderPage({ icon, eyebrow, title, description, meta }) {
    return /*#__PURE__*/ _jsxs("div", {
        className: "mx-auto w-full max-w-5xl p-4 sm:p-6 lg:p-10",
        children: [
            (icon || eyebrow) && /*#__PURE__*/ _jsxs("div", {
                className: "flex items-center gap-2 text-xs font-medium uppercase tracking-wide text-slate-500",
                children: [
                    icon,
                    eyebrow && /*#__PURE__*/ _jsx("span", {
                        children: eyebrow
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("h1", {
                className: "mt-1 text-2xl font-semibold text-slate-900 sm:text-3xl",
                children: title
            }),
            /*#__PURE__*/ _jsx("p", {
                className: "mt-2 max-w-2xl text-sm text-slate-600",
                children: description
            }),
            meta && /*#__PURE__*/ _jsx("div", {
                className: "mt-3 text-xs text-slate-500",
                children: meta
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "mt-6 flex items-center justify-center rounded-xl border border-dashed border-slate-200 bg-white px-6 py-12 text-center text-sm text-slate-500 sm:py-16",
                children: "Coming soon"
            })
        ]
    });
}
